<template>
  <!-- 编辑 -->
  <el-dialog
    title="编辑商品管理"
    @close="close"
    :visible.sync="editFormVisible"
  >
    <div style="width: 60%; margin: 10px auto">
      <el-form ref="form" :model="form" label-width="80px" id="myform">
        <el-form-item label="商品名称">
          <el-input
            v-model="form.title"
            placeholder="请输入商品名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="商品分类">
          <el-select v-model="form.cate" placeholder="请选择分类">
            <el-option
              v-for="item in Commodity_Category"
              :key="item.id"
              :label="item.name"
              :value="item.id"
              >{{ item.name }}</el-option
            >
          </el-select>
        </el-form-item>
        <el-form-item label="商品类型">
          <el-radio-group v-model="form.goods_type" @change="goods_Type">
            <el-radio :label="0">实物商品</el-radio>
            <el-radio :label="1">优惠券</el-radio>
            <el-radio :label="2">余额</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="优惠券" v-if="form.goods_type == 1">
          <div style="display: flex; flex-wrap: wrap">
            <!-- @close="delTagItem(id)" -->
            <el-tag
              v-for="(tag, index) in coupons"
              :key="index"
              style="margin-bottom: 5px; margin-right: 5px"
            >
              {{ tag.name }}
              <span>
                <span class="colorRed">×</span>
                {{ tag.choseNum }} 张</span
              >
            </el-tag>
            <el-button type="primary" @click="cx" style="height: 35px"
              >重选</el-button
            >
          </div>
        </el-form-item>
        <el-form-item label="图片上传" v-if="form.goods_type == 0">
          <!-- <el-upload
          class="avatar-uploader"
          action="#"
          list-type="picture-card"
          :file-list="fileList"
          :show-file-list="false"
          :http-request="
            (file) => {
              return upload_index_img(file);
            }
          "
          style="background: #fff"
        >
          <img v-if="fileList.length > 0" :src="fileList" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload> -->
          <el-upload
            action="#"
            :limit="1"
            ref="upload"
            :file-list="normal"
            :http-request="
              (file) => {
                return upload_index_img(file);
              }
            "
            list-type="picture-card"
            :on-remove="handleRemove"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>

        <el-form-item label="余额充值" v-if="form.goods_type == 2">
          <el-input
            type="number"
            v-model="form.balance"
            placeholder="请输入充值金额"
          ></el-input>
        </el-form-item>
        <el-form-item label="门店">
          <el-select v-model="form.room_id" placeholder="请选择门店">
            <el-option
              v-for="item in storeSelect"
              :key="item.id"
              :label="item.name"
              :value="item.id"
              >{{ item.name }}</el-option
            >
          </el-select>
        </el-form-item>
        <el-form-item label="购买方式">
          <el-radio-group v-model="form.buy_method" @change="buy_method">
            <el-radio :label="1">积分兑换</el-radio>
            <el-radio :label="2">积分加钱购</el-radio>
            <el-radio :label="3">金钱购买</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="积分"
          v-if="form.buy_method == 2 || form.buy_method == 1"
        >
          <el-input
            type="number"
            v-model="form.credit"
            placeholder="请输入积分"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="金钱"
          v-if="form.buy_method == 2 || form.buy_method == 3"
        >
          <el-input
            type="number"
            v-model="form.money"
            placeholder="请输入金钱"
          ></el-input>
        </el-form-item>
        <el-form-item label="库存">
          <el-input
            type="number"
            v-model="form.stock"
            placeholder="请输入库存"
          ></el-input>
        </el-form-item>
        <el-form-item label="排序">
          <el-input
            type="number"
            v-model="form.sort"
            placeholder="排序"
          ></el-input>
        </el-form-item>
        <el-form-item label="商品介绍">
          <el-input
            type="textarea"
            :autosize="{ minRows: 10, maxRows: 4 }"
            placeholder="请输入商品介绍"
            v-model="form.brife"
          >
          </el-input>
        </el-form-item>
        <!-- <el-form-item label="注意事项">
        <el-input
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 4 }"
          placeholder="请输入注意事项"
          v-model="form.notice"
        >
        </el-input>
      </el-form-item>
      <el-form-item label="兑换流程">
        <el-input
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 4 }"
          placeholder="请输入兑换流程"
          v-model="form.exchange_process"
        >
        </el-input>
      </el-form-item> -->
        <el-form-item label="联盟商品">
          <el-tooltip
            :content="'Switch value: ' + form.alliance_goods"
            placement="top"
          >
            <el-switch
              v-model="form.alliance_goods"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-value="1"
              inactive-value="0"
            >
            </el-switch>
          </el-tooltip>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">更改</el-button>
          <el-button @click="Rutern">返回</el-button>
        </el-form-item>
      </el-form>
      <!-- <Coupon :keys="form.goods_type"></Coupon> -->
      <el-dialog
        :visible.sync="showSelecter"
        @close="showSelecter = false"
        width="800px"
      >
        <newSelectCommodityNum
          @close="showSelecter = false"
          @getCommod="getCommod"
          :keys="1"
          :sList="sList"
          :jude="2"
        ></newSelectCommodityNum>
      </el-dialog>
    </div>
  </el-dialog>
</template>
<script>
import newSelectCommodityNum from "@/components/commodity/newSelectCommodityNum.vue";
import { Commodity_category, editGoods } from "@/api/market";
import { couponList } from "@/api/coupon";
import { addImage } from "@/api/comment";
import { storeSelect } from "@/api/employee";
import { mapGetters, mapActions } from "vuex";
export default {
  computed: {
    ...mapGetters(["token", "app_id", "merch_id"]),
  },
  components: {
    newSelectCommodityNum,
  },
  data() {
    return {
      normal: [],
      showSelecter: false,
      coupons: [],
      storeSelect: [],
      sList: [],
      Commodity_Category: [],
      form: {
        id: "",
        app_id: "",
        title: "",
        cate: "",
        goods_type: 0,
        coupon_id: "",
        balance: "",
        room_id: "",
        logo: [],
        buy_method: 1,
        credit: "",
        money: "",
        stock: "",
        sort: "",
        brife: "",
        notice: "1",
        exchange_process: "1",
        alliance_goods: "0",
      },
      coupons_data: [],
      obj: {},
    };
  },
  props: {
    editFormVisible: {
      type: Boolean,
    },
    row: {
      type: Object,
    },
  },
  watch: {
    editFormVisible(val) {
      let that = this;
      if (val == true) {
        let data = {
          token: this.token,
          app_id: this.app_id,
          page: this.page,
        };
        storeSelect({ token: this.token, app_id: this.app_id }).then((res) => {
          console.log("门店", res);
          this.storeSelect = res.data;
        });
        Commodity_category({ app_id: this.app_id }).then((res) => {
          this.Commodity_Category = res.data;
        });
        data.is_exp = 0;
        couponList(data).then((res) => {
          if (res.code == 200) {
            let coupons_data = res.data.result;
            that.obj = coupons_data.find(function (obj) {
              return obj.id === that.row.coupon_id;
            });
          }

          // let obj = coupons_data.find({ id: this.row.coupon_id });
        });
        that.coupons.push(that.obj);
        console.log(this.obj);
        this.form.id = this.row.id;
        this.form.room_id = this.row.room_id;
        this.form.title = this.row.title;
        this.form.cate = this.row.cate;
        this.form.goods_type = this.row.goods_type;
        this.form.balance = this.row.balance;
        this.form.coupon_id = this.row.coupon_id;
        // this.imageUrl = this.row.pic;
        this.form.buy_method = this.row.buy_method;
        this.form.credit = this.row.credit;
        this.form.money = this.row.money;
        this.form.stock = this.row.stock;
        this.form.sort = this.row.sort;
        this.form.brife = this.row.brife;
        this.form.notice = this.row.notice;
        this.form.exchange_process = this.row.exchange_process;
        this.form.alliance_goods = String(this.row.alliance_goods);
        // this.normal = [{
        //   name: 'img', url: this.row.pic
        //   }]
      } else {
        this.coupons = [];
      }
    },
  },
  mounted() {
    // this.getCoupon()
  },
  methods: {
    Rutern() {
      console.log("返回");
      this.$emit("edit", false);
    },
    cx() {
      this.showSelecter = true;
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
      console.log("删除", file);
      this.form.logo.shift();
    },
    //选择优惠券
    getCommod(data) {
      console.log("子组件传递数据", data);
      this.form.coupon_id = data[0].id;
      this.coupons = data;
      // let arrCountId = [];
      // data.forEach(item => {
      //   if (item.choseNum) {
      //     for (var n = 0; n < Number(item.choseNum); n++) {
      //       arrCountId.push(item.id);
      //     }
      //   }
      // });
      // this.sList = data;

      // this.form.reward.coupon = arrCountId.join(",");
      // this.sList = data;
      this.showSelecter = false;
      // console.log("点击", this.form.reward.coupon, this.sList);
    },
    close() {
      this.$emit("close", false);
    },
    //提交
    onSubmit() {
      if(this.form.buy_method == 3){
        this.form.credit = 0
      }
      this.form.app_id = this.app_id;
      this.form.logo = this.form.logo.join(",");
      editGoods(this.form).then((res) => {
        console.log("tianjia ", res);
        if (res.code == 200) {
          this.$message({
            message: res.msg,
            type: "success",
          });
          setTimeout(() => {
            if (this.form.goods_type == 0) {
              this.$refs.upload.clearFiles();
              this.form.logo = [];
            }
            document.getElementById("myform").reset();
          }, 100);
          this.$emit('edit',false)
        }
      });
      console.log("submit!");
    },
    //商品类型
    goods_Type(val) {
      console.log(this.form.goods_type);
      if (this.form.goods_type == 1) {
        this.showSelecter = true;
      } else {
        this.form.coupon_id = "";
      }
    },
    buy_method(val) {
      console.log(this.form.buy_method);
    },
    //获取商品类目
    async Commodity_category() {
      const res = await Commodity_category({
        app_id: this.app_id,
      });
      if (res.code == 200) {
        console.log(res);
        this.Commodity_Category = res.data;
      }
    },
    //获取门店
    getMendian() {
      storeSelect({ token: this.token, app_id: this.app_id }).then((res) => {
        console.log("门店", res);
        this.storeSelect = res.data;
      });
    },
    upload_index_img(file) {
      console.log("wenjian", file.file);
      var that = this;
      var formdata = new FormData();
      formdata.append("token", that.token);
      formdata.append("image", file.file);
      formdata.append("type", "1");
      formdata.append("file_group", "1");
      addImage(formdata).then((res) => {
        if (res.code == 200) {
          console.log("tu", res);
          var data = res.data;
          that.form.logo.push(data.id);
          // this.normal = [{
          //   name:'img',url:data.url
          // }]
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
  },
};
</script>